import { authenticatedGet } from "../../api/authenticatedFetch";

// getBudgetSeries fetches the burn-down series for one budget/period.
// Returns { series: [{day, actual_cum, forecast_cum}], cap }. The whole-project Total
// (budget_id=0) also carries spent_to_date: the actual total over the elapsed window,
// untrimmed by the settle boundary the chart series is cut at.
export const getBudgetSeries = ({ period, budgetId }) =>
  authenticatedGet("/api/v1/financial-control/budget-series", { period, budget_id: budgetId });
